import { render, staticRenderFns } from "./PageQuiz.vue?vue&type=template&id=7b767d6c"
import script from "./PageQuiz.vue?vue&type=script&lang=js"
export * from "./PageQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b767d6c')) {
      api.createRecord('7b767d6c', component.options)
    } else {
      api.reload('7b767d6c', component.options)
    }
    module.hot.accept("./PageQuiz.vue?vue&type=template&id=7b767d6c", function () {
      api.rerender('7b767d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/quiz/PageQuiz.vue"
export default component.exports